const API_BASE_URL = "https://siriusparking.rs"; //server
//const API_BASE_URL = "http://192.168.0.33:8080";  //local

const apiRequest = async (endpoint, method = 'GET', body = null, token = null) => {
    const headers = {
        'Content-Type': 'application/json',
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const options = {
        method,
        headers,
    };

    if (body) {
        options.body = JSON.stringify(body);
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);

    if (!response.ok) {
        const errorBody = await response.json();
        throw new Error(JSON.stringify({Status: response.status, Body: errorBody}));
    }

    const data = await response.json(); // Parse the response body
    //console.log("API data:",data); // Outputs: true
    return data;
};

export default apiRequest;